var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolFusionColor = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 2a2 2 0 0 1 2 2v7.57a35.62 35.62 0 0 0-2.882-3.315A.87.87 0 0 0 16.5 8a.87.87 0 0 0-.618.255C14.719 9.432 10 14.428 10 18.087c0 .68.113 1.322.321 1.914L4 20a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h14Z",
  strokeWidth: 1.75
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.118 8.255A.87.87 0 0 0 16.5 8a.87.87 0 0 0-.618.255C14.719 9.432 10 14.428 10 18.087 10 21.545 12.91 24 16.5 24s6.5-2.455 6.5-5.913c0-3.66-4.719-8.655-5.882-9.832Z",
  strokeWidth: 1.75
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.94 19.399 8.034-9.576M20.408 12.658l-8.197 9.768M22.038 14.833l-6.965 8.3"
})))));
export { SvgToolFusionColor as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-fusion-color.svg";